import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import format from "date-fns/format";
import {
  getBanlTransactionDetailsURL,
  getCashAllocationWriteOffURL,
  getCashAllocationRefundURL,
  getCashAllocationCorrectionTypeURL,
  getCashAllocationCorrectiveTransferURL,
  getCashAllocationCrossAllocationURL,
  getCashAllocationCFIURL,
  getPaymentNoVarianceURL,
  workListTableData,
  getEMailWorkFlowDocs
} from "../../Services/api";
import instance from "../../redux/api";
import { ViewAndEditBankTransaction } from "../bankTransactions/ViewAndEditTxnDialog";
import { CommonButton } from "../common/commonButton";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
import { NAVIGATION_PAGE_NAME } from '../../constants';
import EditPriceDialog from '../bankTransactions/EditPriceDialog';
import {
  getAccountsList,
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { CommonFilterSidebar, CommonPaginationContainer, CommonSelect } from "../common";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { ViewGenericWorkflowDialog } from "../Workflow/ViewGenericWorkflowDialog";
import UpdateGenericWorkflowDialog from "../Workflow/UpdateGenericWorkflowDialog";
import ContraDetailsDialog from "../bankTransactions/ContraDetailsDialog";
import "../common/commonPageStyles.css";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import { Email, Work } from "@mui/icons-material";

export const WorkList = () => {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);

  // Dispatch
  const dispatch = useDispatch();
  const location = useLocation();

  // State
  const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false);
  const [workflowTxnData, setWorkflowTxnData] = useState({});

  const [isOpenEditPriceDialog, setIsOpenEditPriceDialog] = useState(false);

  const [currentWorkflowDetails, setCurrentWorkflowDetails] = useState({});
  const [genericWorkflowDialog, setGenericWorkflowDialog] = useState(false);

  const [updateGenericWorkflowDialog, setUpdateGenericWorkflowDialog] = useState(false);
  const [currentWorkflowName, setCurrentWorkflowName] = useState("");

  const [isOpenContraDialog, setIsOpenContraDialog] = useState(false);
  const [contraDialogData, setContraDialogData] = useState(null);

  //workflow search
  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    WorkFlow_Name: [],
  });
  console.log('searchFieldsPrams', searchFieldsPrams)

  //datepicker from and toDates
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");

  // Filter sidebar state
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  //styles
  const classes = useStyles();

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  useEffect(() => {
    if (userData?.id) {
      getWorklistTableData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  const getWorklistTableData = async () => {
    try {
      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
        }`;
      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      const response = await instance.get(
        `${workListTableData}?${queryParams}&user_id=${userData?.id}`
      );

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response?.data) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
  }, []);

  useEffect(() => {
    if (userData?.id) {
      getWorklistTableData();
    }
  }, [workListTableData, userData?.id]);

  const handleActionsBtn = async (rowData, id) => {
    try {
      const { workflow_name } = rowData?.workflow_json_data;
      setCurrentWorkflowName(workflow_name);

      let workflowAPIURL = "";
      switch (workflow_name) {
        case "CHANGE_BANK_TRANSACTION_AMOUNT":
          workflowAPIURL = getBanlTransactionDetailsURL;
          const response = await instance.get(
            `${workflowAPIURL}${encodeURIComponent(rowData?.bank_txn_id)}`
          );
          setWorkflowTxnData(response?.data);
          setIsOpenEditPriceDialog(true);
          break;
        case "CASH_ALLOCATION_CONTRA_CREATION":
          // const contraResponse = await instance.get(
          //   `/api/endpoint/${rowData.id}`
          // );
          setContraDialogData(rowData);
          setIsOpenContraDialog(true);
          break;
        case "EMAIL_POLICY_ISSUANCE":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_INDORSEMENT_CHANGE":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_CLAIM_SUBMISSION":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_RENEWAL_REVIEW":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_DOCUMENT_REQUEST":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_AMOUNT_RETURN":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "EMAIL_POLICY_CANCELLATION":
          workflowAPIURL = getEMailWorkFlowDocs;
          break;
        case "WF_WRITEOFF":
          workflowAPIURL = getCashAllocationWriteOffURL;
          break;
        case "WF_REFUND":
          workflowAPIURL = getCashAllocationRefundURL;
          break;
        case "WF_CORRECTION_TYPES":
          workflowAPIURL = getCashAllocationCorrectionTypeURL;
          break;
        case "WF_CORRECTIVE_TRANSFER":
          workflowAPIURL = getCashAllocationCorrectiveTransferURL;
          break;
        case "WF_CROSS_ALLOCATION":
          workflowAPIURL = getCashAllocationCrossAllocationURL;
          break;
        case "WF_CFI":
          workflowAPIURL = getCashAllocationCFIURL;
          break;
        case "WF_PAYMENT_NOVARIANCE":
          workflowAPIURL = getPaymentNoVarianceURL;
          break;
        default:
          setUpdateGenericWorkflowDialog(true);
          break;
      }
      const response = await instance.get(`${workflowAPIURL}${encodeURIComponent(rowData?.bank_txn_id)}`);
      setWorkflowTxnData(response?.data);
      setUpdateGenericWorkflowDialog(true);
      // Set workflow steps data
      setCurrentWorkflowDetails(rowData);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUpdateGenericWorkflowDialog = () => {
    // Load Data
    setUpdateGenericWorkflowDialog(false);
    getWorklistTableData();
  };

  const handleTextFieldchange = (name, value) => {
    if (!value || value.length === 0) {
      handleClearWorkflowList();
      return;
    }

    setSearchFieldsPrams((prev) => ({
      ...prev,
      [name]: value, // value is an array
    }));
  };

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  const handlePriceEditCloseDialog = () => {
    setIsOpenEditPriceDialog(false);
    getWorklistTableData();
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { WorkFlow_Name } = searchFieldsPrams;
    if (WorkFlow_Name !== "" || fromDateValue !== "" || toDateValue !== "") {
      disabled = false;
    }
    return disabled;
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const { WorkFlow_Name } = searchFieldsPrams;

    if (Array.isArray(WorkFlow_Name) && WorkFlow_Name.length > 0) {
      const workflowNames = WorkFlow_Name
        .map((wf) => wf.value)
        .join(",");

      getSearchQueryParams += `&workflowName=${workflowNames}`;
    }

    let fromDateReceived = "",
      toDateReceived = "";

    if (fromDateValue && toDateValue) {
      fromDateReceived = format(fromDateValue, "yyyy-MM-dd");
      toDateReceived = format(toDateValue, "yyyy-MM-dd");

      getSearchQueryParams += `&fromDateReceived=${fromDateReceived}&toDateReceived=${toDateReceived}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchWorkflowList = async () => {
    try {
      let queryParams = `?user_id=${userData?.id
        }&skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromDateReceived")
      ) {
        let fromDateReceived = format(
          location?.state?.fromDateValue,
          "yyyy-MM-dd"
        );
        let toDateReceived = format(location?.state?.toDateValue, "yyyy-MM-dd");
        queryParams = `${queryParams}&fromDateReceived=${fromDateReceived}&toDateReceived=${toDateReceived}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${workListTableData}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.log("error", error);
    }
  };

  const handleClearWorkflowList = async () => {
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    // clear fields
    setSearchFieldsPrams({
      WorkFlow_Name: [],
      Transaction_Received_Date: "",
    });
    setFromDateValue("");
    setToDateValue("");
    // Reset page to 1 after clearing
    setPageState((old) => ({
      ...old,
      page: 1,
    }));
  };

  const columns = [
    {
      field: "historical",
      headerName: "",
      width: 15,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params?.row?.workflow_json_data?.workflow_name?.startsWith("EMAIL_") ? (
            <Email sx={{ fontSize: 17 }} />
          ) : (
            <Work sx={{ fontSize: 17 }} />
          )}
        </>
      ),
    },
    {
      field: "Initiated Date",
      headerName: "Initiated Date",
      headerAlign: "center",
      flex: 1,
      valueGetter: (params) =>
        params?.row?.workflow_json_data?.workflow_step[0]?.ctime,
      renderCell: (params) => (
        <span>
          {params?.value ? new Date(params?.value).toLocaleString() : ""}
        </span>
      ),
    },
    {
      field: "Initiated By",
      headerName: "Initiated By",
      headerAlign: "center",
      flex: 1,
      valueGetter: (params) => params?.row?.workflow_json_data?.workflow_step[0]?.user[0]?.user_name,
      renderCell: (params) => (
        <span>
          {params?.value}
        </span>
      ),
    },
    {
      field: "subject_line",
      headerName: "Subject",
      headerAlign: "center",
      flex: 1,

      renderCell: (params) => {
        const value = params?.value || "-";
        const MAX_LEN = 30;

        const truncated =
          value.length > MAX_LEN
            ? value.substring(0, MAX_LEN) + "..."
            : value;

        return (
          <Tooltip title={value} arrow>
            <span>
              {truncated}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "workflow_json_data",
      headerName: "Workflow Name",
      headerAlign: "center",
      flex: 1,
      valueGetter: (params) => params?.row?.workflow_json_data?.workflow_name,
      renderCell: (params) => <span>{params?.value}</span>,
    },
    {
      field: "workflow_status",
      headerName: "Actions",
      headerAlign: "center",
      flex: 1,
      valueGetter: (params) => params?.row?.workflow_status,
      renderCell: (params) => {
        let statusInfo = params?.row?.workflow_status;
        let fontColor = "blue";
        switch (statusInfo?.toLowerCase()) {
          case "completed":
            fontColor = "#28a745";
            break;
          case "approved":
            fontColor = "#FF5A00";
            break;
          case "rejected":
            fontColor = "#dc3545";
            break;
          case "in process":
            const workflowStepData =
              params?.row?.workflow_json_data?.workflow_step;
            if (workflowStepData?.length > 0) {
              const initiaterStepData = workflowStepData.filter(
                (item) => item?.step_name?.toLowerCase() === "initiater"
              );

              let isInitiatorLoggedIn = false;
              initiaterStepData[0]?.user?.forEach((user, index) => {
                if (user?.id === userData?.id) {
                  isInitiatorLoggedIn = true;
                }
              });
              if (!isInitiatorLoggedIn) {
                statusInfo = "Review/Reject";
              }
            }
            break;
          default:
        }

        return (
          <span
            style={{ color: fontColor, cursor: "pointer" }}
            onClick={() =>
              handleActionsBtn(params?.row, params?.row?.bank_txn_id)
            }
          >
            {statusInfo}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    if (isClearPerformed) {
      getWorklistTableData();
    }
  }, [pageState?.pageSize, pageState?.page, isClearPerformed]);

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchWorkflowList();
    }
  };

  const workflowOptions = [
    { label: "EMAIL_POLICY_CANCELLATION", value: "EMAIL_POLICY_CANCELLATION" },
    { label: "EMAIL_AMOUNT_RETURN", value: "EMAIL_AMOUNT_RETURN" },
    { label: "EMAIL_DOCUMENT_REQUEST", value: "EMAIL_DOCUMENT_REQUEST" },
    { label: "EMAIL_RENEWAL_REVIEW", value: "EMAIL_RENEWAL_REVIEW" },
    { label: "EMAIL_CLAIM_SUBMISSION", value: "EMAIL_CLAIM_SUBMISSION" },
    { label: "EMAIL_INDORSEMENT_CHANGE", value: "EMAIL_INDORSEMENT_CHANGE" },
    { label: "EMAIL_POLICY_ISSUANCE", value: "EMAIL_POLICY_ISSUANCE" },
    { label: "CASH_ALLOCATION_CONTRA_CREATION", value: "CASH_ALLOCATION_CONTRA_CREATION" },
    { label: "WF_PAYMENT_NOVARIANCE", value: "WF_PAYMENT_NOVARIANCE" },
    { label: "WF_CFI", value: "WF_CFI" },
    { label: "WF_CROSS_ALLOCATION", value: "WF_CROSS_ALLOCATION" },
    { label: "WF_REFUND", value: "WF_REFUND" },
    { label: "WF_CORRECTION_TYPES", value: "WF_CORRECTION_TYPES" },
    { label: "WF_CORRECTIVE_TRANSFER", value: "WF_CORRECTIVE_TRANSFER" },
    { label: "WF_WRITEOFF", value: "WF_WRITEOFF" },
    { label: "CHANGE_BANK_TRANSACTION_AMOUNT", value: "CHANGE_BANK_TRANSACTION_AMOUNT" }
  ];

  const handleFilterDropdown = (name, value, reason, isMultiple = false) => {
    // When user clears the dropdown
    console.log(name, value, reason, isMultiple)
    if (!value || (isMultiple && value.length === 0)) {
      handleClearWorkflowList();
      return;
    }

    setSearchFieldsPrams((prev) => ({
      ...prev,
      [name]: isMultiple ? value : value?.value ?? value,
    }));
  };

  return (
    <>
      <Box sx={Container}>
        <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
          <CommonFilterSidebar
            isOpen={filterSidebarOpen}
            filterConfigs={[
              {
                type: "custom",
                content: (
                  <>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#000",
                        marginBottom: "12px",
                      }}
                    >
                      Workflow Name
                    </Typography>
                    <CommonSelect
                      multiple={true}
                      placeholder="Select WorkflowName"
                      value={searchFieldsPrams?.WorkFlow_Name || []}
                      handleChange={(event, value, reason) => handleFilterDropdown("WorkFlow_Name", value, reason, true)}
                      options={workflowOptions || []}
                    />
                  </>
                ),
              },
              {
                type: "dateRange",
                label: "Date Received",
                startDate: fromDateValue,
                setStartDate: setFromDateValue,
                endDate: toDateValue,
                setEndDate: setToDateValue,
                maxDate: new Date(),
                onKeyUp: handleEnter,
              },
            ]}
            onApplyFilters={handleSearchWorkflowList}
            onClearFilters={handleClearWorkflowList}
            isLoading={pageState?.isLoading}
            isFilterDisabled={isFilterBtnDisable()}
          />

          {/* Main Content Area */}
          <Box className="main-content-area" sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            <Box className="page-header-container" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px", borderBottom: "1px solid #e0e0e0" }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Typography
                  variant="h5"
                  className="page-heading"
                  sx={{
                    color: "#FF5A01",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  Workflow Tasklist
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <IconButton
                  onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                  className="filter-toggle-button"
                >
                  <FilterListIcon />
                </IconButton>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                position: "relative",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                overflow: "visible",
                transition: "all 0.3s ease",
                border: "1px solid #e8eaf0",
                paddingBottom: "10px",
                margin: "20px",
                "&:hover": {
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                },
              }}
            >
              <DataGrid
                className={classes.pagination}
                loading={pageState?.isLoading}
                rows={pageState?.data ?? []}
                columns={columns}
                rowCount={pageState?.total}
                keepNonExistentRowsSelected
                disableSelectionOnClick
                pagination
                paginationMode="server"
                getRowId={(row) => row?.id}
                page={pageState.page - 1}
                pageSize={pageState?.pageSize ?? 25}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageSizeChange={(newPageSize) => {
                  return setPageState((old) => {
                    setPaginationCount(
                      getPaginationCount(pageState?.total, newPageSize)
                    );
                    return { ...old, pageSize: newPageSize, page: 1 };
                  });
                }}
                sx={{
                  border: "none",
                  flex: 1,
                  minHeight: 0,
                  "& .MuiDataGrid-root": {
                    border: "none",
                    height: "100%",
                  },
                  "& .MuiDataGrid-main": {
                    height: "100%",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e0e0e0",
                    minHeight: "52px !important",
                    maxHeight: "52px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "transparent",
                    fontWeight: "600",
                    color: "#FF5A01",
                    fontSize: "14px",
                    padding: "12px 16px",
                    borderBottom: "none",
                    overflow: "visible",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "600",
                      fontSize: "14px",
                      overflow: "visible",
                      textOverflow: "clip",
                      whiteSpace: "normal",
                      lineHeight: "1.4",
                      width: "100%",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "#FF5A01",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "#FF5A01",
                    },
                  },
                  "& .MuiDataGrid-columnHeader[data-field='Actions']": {
                    minWidth: toggle?.isOpen
                      ? "315.137px !important"
                      : "366px !important",
                  },
                  "& .MuiDataGrid-row": {
                    transition: "all 0.2s ease",
                    borderBottom: "1px solid #f0f0f0",
                    "&:hover": {
                      backgroundColor: "rgba(255, 90, 1, 0.04)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                    },
                    "&:nth-of-type(even)": {
                      backgroundColor: "#fafafa",
                      "&:hover": {
                        backgroundColor: "rgba(255, 90, 1, 0.04)",
                      },
                    },
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 16px",
                    fontSize: "13px",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "2px solid #e0e0e0",
                    backgroundColor: "#f8f9fa",
                    minHeight: "48px",
                    maxHeight: "48px",
                    paddingBottom: "8px",
                    paddingTop: "8px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    position: "relative",
                    zIndex: 1,
                    "& .MuiTablePagination-root": {
                      color: "#666",
                      paddingRight: "16px",
                      margin: 0,
                      minHeight: "32px",
                    },
                    "& .MuiTablePagination-selectLabel": {
                      fontSize: "13px",
                      margin: 0,
                    },
                    "& .MuiTablePagination-displayedRows": {
                      fontSize: "13px",
                      margin: 0,
                    },
                    "& .MuiTablePagination-actions": {
                      marginLeft: "8px",
                      "& .MuiIconButton-root": {
                        padding: "4px",
                      },
                    },
                    "& .MuiTablePagination-select": {
                      margin: "0 8px",
                      padding: "4px 8px",
                    },
                    "& .MuiTablePagination-toolbar": {
                      minHeight: "32px",
                      padding: 0,
                    },
                  },
                  "& .MuiDataGrid-toolbarContainer": {
                    padding: "12px 16px",
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    "& .MuiButton-root": {
                      color: "#FF5A01",
                      fontSize: "13px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "rgba(255, 90, 1, 0.1)",
                      },
                    },
                  },
                  "& .MuiDataGrid-loadingOverlay": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                  },
                }}
                components={{
                  Toolbar: GridToolbarContainer,
                  NoRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ color: "#999" }}
                    >
                      <Typography variant="body2" sx={{ color: "#999" }}>
                        No Work List
                      </Typography>
                    </Stack>
                  ),
                }}
              />
              <Stack
                sx={{
                  position: "absolute",
                  bottom: "16px",
                  right: "20px",
                  zIndex: 10,
                  backgroundColor: "#f8f9fa",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                <CommonPaginationContainer
                  count={paginationCount + 1}
                  pageState={pageState}
                  setPageState={setPageState}
                />
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      {isOpenTxnDialog && (
        <ViewAndEditBankTransaction
          isOpenTxnDialog={isOpenTxnDialog}
          setIsOpenTxnDialog={setIsOpenTxnDialog}
          txnMode={"VIEW"}
          txnData={workflowTxnData}
        />
      )}

      {isOpenEditPriceDialog && (
        <EditPriceDialog
          openEditPriceDialog={isOpenEditPriceDialog}
          handlePriceEditCloseDialog={handlePriceEditCloseDialog}
          txnData={workflowTxnData}
          currentWorkflowDetails={currentWorkflowDetails}
          navigatedFrom={NAVIGATION_PAGE_NAME.WORK_LIST}
          disabled={false}
        />
      )}


      {updateGenericWorkflowDialog && (
        <UpdateGenericWorkflowDialog
          openUpdateGenericWorkflowDialog={updateGenericWorkflowDialog}
          handleUpdateGenericWorkflowDialog={handleUpdateGenericWorkflowDialog}
          workflowName={currentWorkflowName}
          currentWorkflowDetails={currentWorkflowDetails}

          workflowTxnData={workflowTxnData}
        />
      )}

      {isOpenContraDialog && (
        <ContraDetailsDialog
          open={isOpenContraDialog}
          onClose={() => setIsOpenContraDialog(false)}
          contraData={contraDialogData}
          currentWorkflowDetails={currentWorkflowDetails}
        />
      )}
    </>
  );
};
